import { REDUCE_BOARD_POLICIES } from '../../constants/actions/policies';

export function reduceBoardPolicies(payload) {
    return {
        type: REDUCE_BOARD_POLICIES,
        payload,
    };
}
